import React from 'react'
import Intro from '../sections/intro/intro.component'
import EducationProjects from '../sections/projects/education-projects.component'
import ReleasedProjects from '../sections/projects/released-projects.component'

export default function MainPage() {
  return (
    <div className='container' style={{maxWidth: "1100px"}}>
      <Intro/>
    </div>
  )
}
